import { useState, useReducer, useEffect, useCallback, useRef } from "react";
import DataGrid, {
  Column,
  Lookup,
  RequiredRule,
  Item,
  Paging,
  Pager,
  ColumnFixing,
  FormItem,
  Export,
  ColumnChooser,
  Toolbar,
  HeaderFilter,
  MasterDetail,
} from "devextreme-react/data-grid";
import { Toast } from "devextreme-react/toast";
import { confirm } from "devextreme/ui/dialog";
import ScrollView from "devextreme-react/scroll-view";
import { Popup } from "devextreme-react/popup";
import FileUploader from "devextreme-react/file-uploader";
import * as actions from "../../../actions/dashboard";
import dashboardReducer from "../../../reducers/dashboard";
import { GRID_CONFIG, ViewFiles } from "./utils";
import { set, get, getTypeOfFile, onDownloadFile } from "../../../common/utils";
import NEXUS_CONST from "../../../common/constants";
import AsyncCallHandler from "../../../common/AsyncCallHandler";
import moment from "moment";
import Button1 from "devextreme-react/button";
import * as action from "../../../actions/rps";
import * as actionA3 from "../../../actions/sa3";
import Sps from "../../sps/Sps";
import SA3 from "../../sa3/SA3";
import RailViewData from "./RailViewData";
import { alert } from "devextreme/ui/dialog";
import { difference } from "lodash";
import CustomStore from "devextreme/data/custom_store";
import { Autocomplete } from "devextreme-react/autocomplete";
import { searchValueByOneProperty } from "../../settings/utils";
import {
  ALLOWED_FILE_EXTENSIONS,
  ALLOWED_MIME_TYPES,
} from "../../../constants/allowedUploadTypes";
import { checkUploadFilesValid } from "../../../utils/fileValidator";
import config from "../../../common/config";

const initialRailState = {
  safety: "",
  railActions: "",
  railEscalated: "",
  railNotes: "",
  railStartDate: "",
  railDueDate: "",
  compDate: "",
  railPriority: "",
  railStatus: "",
  railOwner: "",
  topThree: "",
  moduleID: "",
  moduleLink: "",
  module: "",
  railPdca: "",
  railPlan: "",
  railDo: "",
  railCheck: "",
  railAct: "",
  railImageName: "",
};

const initialState = {
  railGridData: [],
  peopleList: null,
  tiersList: null,
  rpsGridData: null,
  peopleList: [],
  userPref: null,
  tierInfo: {},
  pplListInSite: [],
};

const GridView = ({
  siteId,
  tierId,
  tabData,
  currenttab,
  tab,
  siteUid,
  isEditable,
  activeItem,
  widgetId,
  siteDate,
}) => {
  const [state, dispatch] = useReducer(dashboardReducer, initialState);
  const dataGrid = useRef(null);
  const loggedinUser = get("hid");
  const [responseData, setResponseData] = useState([]);
  const [sqdicp, setSqdicp] = useState([""]);
  const [isLoadPanelVisible, setIsLoadPanelVisible] = useState(false);
  const [customsqdicp, setCustomSqdicp] = useState([""]);
  const [tierIdList, settierIdList] = useState([]);
  const [finalSQDICP, setFinalSQDICP] = useState([""]);
  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    type: "info",
    message: "",
  });
  const [isPopupVisible, setIsPopupVisibility] = useState(false);
  const [rpsPopUpMgr, setRPSPopUpMgr] = useState(false);
  const [rpsEditPopUpMgr, setRPSEditPopUpMgr] = useState(false);
  const [a3EditPopUpMgr, setA3EditPopUpMgr] = useState(false);
  const [isFilePopupVisible, setIsFilePopupVisibility] = useState(false);
  const [railViewInfo, setPopupData] = useState({ initialRailState });
  const [selectedFiles, setSlectedFiles] = useState(null);
  const [view, setView] = useState(false);
  const [sDate, setSDate] = useState(new Date());
  const [eDate, setEDate] = useState(new Date());
  const [exportFilter, setExportFilter] = useState(0);
  const [popUpImages, setPopUpImages] = useState([]);
  const [rpsIdRail, setRpsIdRail] = useState(null);
  const [a3IDRail, setA3IDRail] = useState(null);
  const [railTierId, setRailTierId] = useState(tierId);
  const TIER_LBL = "People in Tier",
    ORG_LBL = "People in Organization";
  const [scrollConfig] = useState({
    showScrollbar: "always",
    scrollByContent: true,
    scrollByThumb: true,
  });
  const [allFilterValues, setAllFilterValues] = useState({});
  const [rpsIdAction, setRpsIdAction] = useState(1);

  let railConfig = { ...GRID_CONFIG.RAIL_GRID_CONFIG };
  const stat = ["Not Started", "In Progress", "Completed"];
  const railStatus = [
    { value: "Not Started", text: "Not Started" },
    { value: "In Progress", text: "In Progress" },
    { value: "Completed", text: "Completed" },
  ];
  const pdca = ["Plan", "Do", "Check", "Act"];
  const priority = ["High", "Medium", "Low"];
  let delList = [];

  let { rpsGridData, peopleList, userPref, pplListInSite } = state;
  let listTires = [];

  const GRID_COLS = JSON.stringify([
    "id",
    "sqdcp",
    "tierlevel",
    "tiername",
    "actions",
    "notes",
    "startDate",
    "dueDate",
    "rpsId",
    "completedDate",
    "openAge",
    "status",
    "owner",
    "lsImageName",
    "pdca",
  ]);
  const rpslink = {
    color: "pink",
    padding: "10px",
    fontFamily: "Arial",
    textDecorationLine: "underline",
    cursor: "pointer",
  };
  const rpslinkblank = {
    backgroundColor: "grey",
    textAlign: "center",
    width: "100%",
    font: 14,
    color: "grey",
    cursor: "default",
    opacity: 0.2,
  };

  const setDeleted = (d) => {
    delList = d;
  };
  const onRowPrepared = (e) => {
    if (
      e.rowType == "data" &&
      moment(e.data.dueDate).isSameOrBefore(
        moment(siteDate !== undefined ? siteDate : new Date())
      ) &&
      (e.data.status === railStatus[0].value ||
        e.data.status === railStatus[1].value ||
        e.data.status === railStatus[0].value.replace(/ /g, "") ||
        e.data.status === railStatus[1].value.replace(/ /g, "") ||
        e.data.status === "In Progess")
    ) {
      e.rowElement.style.backgroundColor = "#FA5F55";
      e.rowElement.classList.remove("dx-row-alt");
    } else {
      return false;
    }
    // remove commented Code
    // if (
    //   e.rowType == "data" &&
    //   (e.data.priority == "High" || e.data.priority == 1)
    // ) {
    //   e.rowElement.style.backgroundColor = "#FFDDDD";
    // } else if (
    //   e.rowType == "data" &&
    //   (e.data.priority == "Medium" || e.data.priority == 2)
    // ) {
    //   e.rowElement.style.backgroundColor = "#FFEBAB";
    // } else if (
    //   e.rowType == "data" &&
    //   (e.data.priority == "Low" || e.data.priority == 3)
    // ) {
    //   e.rowElement.style.backgroundColor = "#D0E5C1";
    // } else if (e.rowType == "data" && e.data.escTierId == 1) {
    //   e.rowElement.style.backgroundColor = "#D0E5C1";
    // } else {
    //   return false;
    // }
  };
  useEffect(() => {
    let siteInfo = siteUid ? `&siteId=${siteUid}` : "";

    actions.fetchUsers(dispatch, `tierId=${tierId}` + siteInfo);
    actions.getTierInfo(dispatch, `siteid=${siteUid}&tierid=${tierId}`);

    if (siteUid) actions.fetchTiersList(dispatch, siteUid);
    actions.fetchRailGridData(dispatch, tierId + siteInfo);
    if (siteUid) {
      actions.getPeopleList(dispatch, `tierId=${tierId}` + siteInfo);
      let items = railConfig.editing.form.items[0].items;
      let tierLevel = items.find((d) => {
        if (d && d.dataField && d.dataField == "tier") return d;
      });
      if (!tierLevel)
        railConfig.editing.form.items[0].items.push({
          dataField: "tier",
          colSpan: 2,
        });
    } else {
      actions.getPeopleList(dispatch, `tierId=${tierId}&siteid=${siteId}`);
      let items = railConfig.editing.form.items[0].items;
      let tierLevel = items.find((d) => {
        if (d && d.dataField && d.dataField == "tier") return d;
      });
      if (tierLevel) railConfig.editing.form.items[0].items.pop();
    }

    if (!isEditable) {
      railConfig.editing.allowUpdating = false;
      railConfig.editing.allowAdding = false;
      railConfig.editing.allowDeleting = false;
    } else {
      railConfig.editing.allowUpdating = true;
      railConfig.editing.allowAdding = true;
      railConfig.editing.allowDeleting = true;
    }
    if (tabData == undefined) {
    } else {
      var test = tabData?.map((d) => {
        return d.title;
      });
      setSqdicp(test);
    }
  }, []);

  useEffect(() => {
    actions.fetchUserPref(
      dispatch,
      `=${siteUid ? 0 : tierId}&SiteUID=${
        siteUid ? siteUid : siteId
      }&widgetID=${widgetId}`
    );
  }, [widgetId, tierId, siteId, siteUid, !view]);

  useEffect(() => {
    if (state.railGridData) {
      const allFilterVals = {};
      dataGrid.current.instance.getVisibleColumns().forEach((column) => {
        const dataField = column.dataField;
        allFilterVals[dataField] = [
          ...new Set(state.railGridData.map((item) => item[dataField])),
        ];
      });
      setAllFilterValues(allFilterVals);
    }
  }, [state.railGridData]);

  useEffect(() => {
    if (userPref) set("userPref", userPref);
    if (dataGrid && dataGrid.current) {
      let cols = dataGrid.current.instance.getVisibleColumns();
      let gridIns = dataGrid.current.instance;
      if (userPref && userPref.filter) {
        let saveCols = JSON.parse(userPref.filter);
        cols.pop();
        if (saveCols.length > 0) {
          cols.forEach((d) => {
            let isExist = saveCols.findIndex((v) => v == d.dataField);
            if (isExist > -1) {
              gridIns.columnOption(d.dataField, "visible", true);
            } else gridIns.columnOption(d.dataField, "visible", false);
          });
        }
      }
      let filterInfo = get("colFil_" + widgetId);
      if (
        userPref &&
        userPref.columnFilter &&
        filterInfo &&
        filterInfo.length == 0
      ) {
        let colsFil = userPref.columnFilter
          ? JSON.parse(userPref.columnFilter)
          : [];
        cols.forEach((d) => {
          let colFils = colsFil.find((j) => j.id == d.dataField);
          if (
            colFils &&
            "exclude" !== colFils.filter &&
            "include" !== colFils.filter
          )
            gridIns.columnOption(d.dataField, "filterValues", colFils.filter);
          else if (
            colFils &&
            ("exclude" === colFils.filter || "include" === colFils.filter)
          )
            gridIns.columnOption(d.dataField, "filterType", colFils.filter);
          else if (!colFils && d.dataField !== "sqdcp")
            gridIns.columnOption(d.dataField, "filterType", "exclude");
        });
      }
    }

    // Width resizing based on user pref
    if (
      userPref &&
      userPref.layoutColumns &&
      dataGrid !== null &&
      dataGrid.current !== null &&
      dataGrid.current.instance !== null
    ) {
      let cols = JSON.parse(userPref.layoutColumns);

      if (typeof cols === "object") {
        const dataGridInstance = dataGrid.current.instance;

        Object.entries(cols).forEach(([prop, value]) => {
          dataGridInstance.columnOption(prop, "width", value);
        });
        dataGrid.current.instance.resize();
      }
    }
  }, [userPref, view]);

  useEffect(() => {
    set("railData", state.railGridData);
    let fSQDICP = state.railGridData && [
      ...new Set(state.railGridData.map((d) => d.sqdcp)),
    ];
    let arraVals = [];
    for (const element of fSQDICP) {
      arraVals.push({ value: `${element}`, text: `${element}` });
    }
    setFinalSQDICP(arraVals);
  }, [state.railGridData]);

  useEffect(() => {
    if (tabData == undefined) {
      let siteInfo = `site=` + siteUid;
      AsyncCallHandler(
        NEXUS_CONST.GET_CUSTOMSQDICP_DATA + siteInfo,
        NEXUS_CONST.GET
      ).then((res) => {
        setResponseData(res?.data);

        const unique = [
          ...new Set(res.data?.map((obj) => obj.metricGroupname)),
        ];
        setCustomSqdicp(unique);
      });
    }
  }, []);

  // useEffect(() => {
  //   let siteval = siteUid ? siteUid : siteId;
  //   let tierVal = siteUid ? "0" : tierId;
  //   let widgeVal = widgetId ? widgetId : "master";

  //   AsyncCallHandler(
  //     NEXUS_CONST.GER_GRID_SETTINGS +
  //       `?tierId=${tierVal}&SiteUID=${siteval}&widgetID=${widgeVal}&userid=${loggedinUser}`,
  //     NEXUS_CONST.GET
  //   ).then((res) => {
  //     if (
  //       res &&
  //       res.data.layoutColumns &&
  //       dataGrid !== null &&
  //       dataGrid.current !== null &&
  //       dataGrid.current.instance !== null
  //     ) {
  //       let cols = JSON.parse(res.data.layoutColumns);

  //       if (typeof cols === "object") {
  //         const dataGridInstance = dataGrid.current.instance;

  //         Object.entries(cols).forEach(([prop, value]) => {
  //           dataGridInstance.columnOption(prop, "width", value);
  //         });
  //         dataGrid.current.instance.resize();
  //       }
  //     }
  //   });
  // }, [dataGrid, view]);

  useEffect(() => {
    return () => {
      saveUserPref();
      // SaveGridSettings();
    };
  }, []);

  useEffect(() => {
    set("tiersList", state.tiersList);
  }, [state.tiersList]);

  const saveUserPref = () => {
    let data = get("cols_" + widgetId);
    let colFil = get("colFil_" + widgetId);
    let userPref = get("userPref");
    let info = {
      layoutID: 0,
      tierID: siteUid ? 0 : tierId,
      siteUID: siteUid ? siteUid : siteId,
      widgetId: widgetId,
      module: "RAIL",
    };

    if (data && data.length > 0) {
      // let info = {
      //   layoutID: 0,
      //   tierID: siteUid ? 0 : tierId,
      //   siteUID: siteUid ? siteUid : siteId,
      //   widgetId: widgetId,
      //   module: "RAIL",
      //   filter: JSON.stringify(data),
      // };

      info.filter = JSON.stringify(data);
      if (userPref && userPref.filter) {
        if (userPref.filter !== info.filter) {
          info.layoutID = userPref.layoutID;
          // actions.updateUserPref(dispatch, info);
        }
      } else if (userPref && !userPref.filter && GRID_COLS !== info.filter) {
        info.layoutID = 0;
        // actions.updateUserPref(dispatch, info);
      }
    }
    if (colFil && colFil.length > 0) {
      // let info = {
      //   layoutID: 0,
      //   tierID: siteUid ? 0 : tierId,
      //   siteUID: siteUid ? siteUid : siteId,
      //   widgetId: widgetId,
      //   module: "RAIL",
      //   columnFilter: colFil ? JSON.stringify(colFil) : null,
      // };
      if (userPref && userPref.columnFilter !== info.columnFilter) {
        info.columnFilter = colFil ? JSON.stringify(colFil) : null;
        // actions.updateUserPref(dispatch, info);
      }
    }

    let columns = get(`RAIL_GRID_${widgetId}`);
    const newColumnWidths = {};
    if (columns) {
      columns.forEach((column) => {
        newColumnWidths[column.dataField] = column.width;
      });

      let data = {
        // layoutID: 0,
        // tierID: siteUid ? 0 : tierId,
        // siteUID: siteUid ? siteUid : siteId,
        userID: loggedinUser,
        module: "RAIL",
        layoutName: "RAIL",
        layoutColumns: JSON.stringify(newColumnWidths),
        widgetID: widgetId,
      };
      info.userID = loggedinUser;
      info.module = "RAIL";
      info.layoutName = "RAIL";
      info.layoutColumns = JSON.stringify(newColumnWidths);
      info.widgetID = widgetId;
    }

    actions.updateUserPref(dispatch, info);
  };

  const onEditingStart = () => setDeleted([]);

  const onColumnsResizing = (e) => {
    var activeCols = e.component.getVisibleColumns();

    set(`RAIL_GRID_${widgetId}`, activeCols);
  };

  const SaveGridSettings = () => {
    let columns = get(`RAIL_GRID_${widgetId}`);
    const newColumnWidths = {};
    if (columns) {
      columns.forEach((column) => {
        newColumnWidths[column.dataField] = column.width;
      });

      let data = {
        layoutID: 0,
        tierID: siteUid ? 0 : tierId,
        siteUID: siteUid ? siteUid : siteId,
        userID: loggedinUser,
        module: "RAIL",
        layoutName: "RAIL",
        layoutColumns: JSON.stringify(newColumnWidths),
        widgetID: widgetId,
      };
      AsyncCallHandler(
        NEXUS_CONST.POST_RAILGRID_COLUMNSSAVE,
        NEXUS_CONST.POST,
        data
      ).then((res) => {
        if (res) {
        }
      });
    }
  };

  function setStateValue(rowData, value) {
    this.defaultSetCellValue(rowData, value);
  }

  function getFilteredRows(options) {
    return {
      store: responseData,
      filter: options.data
        ? ["metricGroupname", "=", options.data.sqdcp]
        : null,
    };
  }

  const cellRender = (data, e) => {
    let top3tpl =
      data.data && data.data.top3 < 9 && data.data && data.data.top3 > 0 ? (
        <span className="fa-layers fa-fw">
          <i className="fas fa-star fa-2x top3-icon"></i>
          <span
            className="fa-layers-text fa-inverse top3-txt primary-txt-clr"
            data-fa-transform="shrink-8 down-3"
          >
            {data.data.top3}{" "}
          </span>
        </span>
      ) : (
        ""
      );
    let excltpl =
      data.data && data.data.escTierId > 0 ? (
        <span className="fa-layers fa-fw">
          <i
            className="fas fa-flag fa-2x top3-icon"
            fade="true"
            size="xs"
            style={{ color: "#f60428" }}
          ></i>
          {/* <i className="fa-sharp fa-solid fa-flag" fade size="xs" style={{color: "#f60428",}} /> */}
          <span
            className="fa-layers-text fa-inverse top3-txt primary-txt-clr"
            data-fa-transform="shrink-8 down-3"
          >
            {}{" "}
          </span>
        </span>
      ) : (
        ""
      );
    let returnVal = "";
    return (
      <span>
        {top3tpl}
        {excltpl} <span className="w-50">{data.value}</span>
      </span>
    );
  };
  const useMethod = () => {};

  const renderContent = () => {
    return (
      <ScrollView
        contentContainerStyle={{ flexGrow: 1, height: "550px" }}
        id="scrollview"
        {...scrollConfig}
      >
        {config.DEV_DISPLAY_OPTIONS && (
          <div class="row">
            <div class="col4">
              <div>
                <label className="view-grid-info"> SQDICP :</label>
                <span> {railViewInfo.railViewInfo.sqdcp}</span>
              </div>
              <br />
              <br />
              <div>
                <label className="view-grid-info"> Escalated :</label>
                <span>
                  {" "}
                  {railViewInfo.railViewInfo.escTierId == "0"
                    ? "False"
                    : "True"}{" "}
                </span>
              </div>
              <br />
              <br />
            </div>
            <div class="col4">
              <div>
                <label className="view-grid-info"> Start Date :</label>
                <span>
                  {" "}
                  {new Date(
                    railViewInfo.railViewInfo.startDate
                  ).toLocaleDateString()}{" "}
                </span>
              </div>
              <br />
              <br />
              <div>
                <label className="view-grid-info"> Due Date :</label>
                <span>
                  {" "}
                  {new Date(
                    railViewInfo.railViewInfo.dueDate
                  ).toLocaleDateString()}{" "}
                </span>
              </div>
              <br />
              <br />
            </div>
            <div class="col4">
              <div>
                <label className="view-grid-info"> Status :</label>
                <span> {railViewInfo.railViewInfo.status} </span>
              </div>
              <br />
              <br />
              <div>
                <label className="view-grid-info"> Owner :</label>
                <span> {railViewInfo.railViewInfo.ownerName} </span>
              </div>
              <br />
              <br />
            </div>

            <div class="col4">
              <div>
                <label className="view-grid-info"> Actions :</label>
                <span> {railViewInfo.railViewInfo.actions}</span>
              </div>
              <br />
              <br />
              <div>
                <label className="view-grid-info"> Notes :</label>
                <span> {railViewInfo.railViewInfo.notes} </span>
              </div>
              <br />
              <br />
            </div>
            <div class="col4">
              <div>
                <label className="view-grid-info"> Completed Date :</label>
                <span>
                  {" "}
                  {new Date(
                    railViewInfo.railViewInfo.completedDate
                  ).toLocaleDateString()}{" "}
                </span>
              </div>
              <br />
              <br />
              <div>
                <label className="view-grid-info">Priority :</label>
                <span> {railViewInfo.railViewInfo.priority} </span>
              </div>
              <br />
              <br />
            </div>
            <div class="col4">
              <div>
                <label className="view-grid-info"> Top 3 :</label>
                <span> {railViewInfo.railViewInfo.top3} </span>
              </div>
              <br />
              <br />
              <div>
                <label className="view-grid-info"> PDCA :</label>
                <span> {railViewInfo.railViewInfo.pdca} </span>
              </div>
              <br />
              <br />
            </div>
            <div class="col4">
              <div>
                <label className="view-grid-info"> Plan :</label>
                <span> {railViewInfo.railViewInfo.plan} </span>
              </div>
              <br />
              <br />
              <div>
                <label className="view-grid-info"> Do :</label>
                <span> {railViewInfo.railViewInfo.do} </span>
              </div>
              <br />
              <br />
            </div>
            <div class="col4">
              <div>
                <label className="view-grid-info"> Check :</label>
                <span> {railViewInfo.railViewInfo.check} </span>
              </div>
              <br />
              <br />
              <div>
                <label className="view-grid-info"> Act :</label>
                <span> {railViewInfo.railViewInfo.act} </span>
              </div>
              <br />
            </div>
            <div class="col4">
              <div>
                <label className="view-grid-info"> Related To :</label>
                <span> {railViewInfo.railViewInfo.moduleLink} </span>
              </div>
            </div>
          </div>
        )}
      </ScrollView>
    );
  };
  const rpscellRender = (data) => {
    if (data.data.module === "RPS") {
      if (data.value > 0) {
        return data.value ? (
          <a
            onClick={() => {
              if (data.value > 0) {
                setRPSEditPopUpMgr(true);

                setRPSPopUpMgr(true);
                action.fetchRPSGridData(dispatch, data.value);
                setRpsIdRail(data.value);
                setRailTierId(data.data.tier);
              }
            }}
          >
            {data.data.moduleLink}
          </a>
        ) : (
          ""
        );
      }
    } else if (data.data.module === "A3") {
      if (data.value > 0) {
        return data.value ? (
          <a
            onClick={() => {
              if (data.value > 0) {
                setA3EditPopUpMgr(true);
                // setRPSPopUpMgr(true);
                actionA3.fetchA3GridData(dispatch, data.value);
                setA3IDRail(data.value);
                setRailTierId(data.data.tier);
              }
            }}
          >
            {data.data.moduleLink}
          </a>
        ) : (
          ""
        );
      }
    }
  };

  const onContentReady = (e) => {
    var activeCols = e.component.getVisibleColumns();
    let cCnt = activeCols.length - 1;
    let col = [],
      colFil = [];
    for (let i = 0; i < cCnt; i++) {
      let filter = null;
      col.push(activeCols[i]["dataField"]);
      if (activeCols[i]["filterValues"]) {
        if (activeCols[i].filterType === "exclude") {
          const intParsedArray = allFilterValues[
            activeCols[i]["dataField"]
          ].map((x) => {
            let parsed = parseInt(x);
            return isNaN(parsed) ? x : parsed;
          });
          const invertedFilter = difference(
            intParsedArray,
            activeCols[i]["filterValues"]
          );
          filter = invertedFilter;
        } else {
          filter = activeCols[i]["filterValues"];
        }
      } else if (activeCols[i]["filterValue"])
        filter = activeCols[i]["filterValue"];
      else if (activeCols[i]["filterType"])
        filter = activeCols[i]["filterType"];
      if (filter)
        colFil.push({ id: [activeCols[i]["dataField"]], filter: filter });
    }
    set("cols_" + widgetId, col);
    set("colFil_" + widgetId, colFil);
    var columnChooserView = e.component.getView("columnChooserView");
    if (!columnChooserView._popupContainer) {
      columnChooserView._initializePopupContainer();
      columnChooserView.render();
      columnChooserView._popupContainer.option("position", {
        of: e.element,
        my: "right top",
        at: "right top",
        offset: "0 50",
      });
    }
  };

  const lengthyTextCellRender = (data) => {
    let cellText = "";
    if (data.text && data.text.length > 120) {
      //   cellText = (
      //     <ShowMoreText
      //       lines={1}
      //       more="Show More"
      //       less="Show Less"
      //       className="content-css"
      //       anchorClass="my-anchor-css-class"
      //       expanded={false}
      //       width={280}
      //       onClick={useMethod}
      //       truncatedEndingComponent={"... "}
      //     >
      //       {data.text}
      //     </ShowMoreText>
      //   );
      //   return (data.text = cellText);
      // } else {
      cellText = data.text;
      return (data.text = (
        <span title={cellText}>{cellText.slice(0, 120) + " ..."} </span>
      ));
    } else {
      cellText = data.text;
      return (data.text = cellText);
    }
  };

  const validationHandler = useCallback((e) => {
    let chngs = e.changes;

    if (chngs.length > 0) {
      let tempstartDate =
        chngs[0].data && chngs[0].data.hasOwnProperty("startDate")
          ? moment(chngs[0].data.startDate).startOf("day").format("YYYY-MM-DD")
          : moment(chngs[0].key.startDate).startOf("day").format("YYYY-MM-DD");
      let tempdueDate =
        chngs[0].data && chngs[0].data.hasOwnProperty("dueDate")
          ? moment(chngs[0].data.dueDate).startOf("day").format("YYYY-MM-DD")
          : moment(chngs[0].key.dueDate).startOf("day").format("YYYY-MM-DD");
      let tempCompletionDate =
        chngs[0].data && chngs[0].data.hasOwnProperty("completedDate")
          ? chngs[0].data.completedDate
            ? moment(chngs[0].data.completedDate)
                .startOf("day")
                .format("YYYY-MM-DD")
            : chngs[0].data.completedDate
          : chngs[0].key.completedDate
          ? moment(chngs[0].key.completedDate)
              .startOf("day")
              .format("YYYY-MM-DD")
          : chngs[0].key.completedDate;

      if (
        (tempdueDate !== "" && moment(tempdueDate).isBefore(tempstartDate)) ||
        (tempCompletionDate &&
          moment(tempCompletionDate).isBefore(tempstartDate))
      ) {
        alert(
          "Please make sure Due Date/Completion Date are not before Start Date",
          "Alert"
        );
        e.cancel = true;
      }
    }

    if (
      chngs.length > 0 &&
      chngs[0].type !== "remove" &&
      chngs[0]["data"]["top3"]
    ) {
      let top3 = chngs[0]["data"]["top3"];
      let railData = get("railData");
      let isTop3Exist = railData.findIndex(
        (d) => top3 < 9 && d.top3 == top3 && d.id !== chngs[0]["data"]["id"]
      );
      if (isTop3Exist > -1) {
        e.cancel = true;
        let result = confirm(
          "Today's top 3 already have top " +
            top3 +
            " value, Do you want to change it?",
          "Confirm changes"
        );
        result.then((res) => {
          if (res) {
            let info = chngs[0];
            let act = info.type;
            let key = info.key;
            let val = info.data;
            if (act == "update") {
              onRowUpdated({ data: { ...key, ...val } });
            } else if (act == "insert") {
              onRowInserted(info);
            }
            e.component.cancelEditData();
          } else e.cancel = true;
        });
      }
    }
  }, []);

  const onRowUpdated = (data) => {
    let {
      sqdcp,
      dueDate,
      notes,
      owner,
      pdca,
      priority,
      startDate,
      completedDate,
      status,
      plan,
      act,
      check,
      escTierId,
      top3,
      filePath,
      imageName,
      lsImageName = [],
      ownerEmail,
      ownerName,
    } = data.data;

    // return;
    if (siteUid) {
      let getTiersList = get("tiersList");
      let tierInfo = getTiersList.find((d) => {
        if (d.tierID == data.data.tier) return d;
      });
      if (tierInfo) tierId = tierInfo.tierID;
    }
    if (delList.length)
      delList.map((f) =>
        actions.deleteFile(
          `id=${data.data.id}&module=RAIL&fileName=${f}&folderName=Rail`
        )
      );
    let formData = new FormData();

    formData.append("ActionId", data.data.id);
    formData.append("ModuleID", data.data.moduleID);
    formData.append("Module", data.data.module);
    formData.append(
      "EscTierId",
      data.data.escTierId == "true" || data.data.escTierId == "1" ? 1 : 0
    );
    formData.append("Sqdcp", sqdcp);
    formData.append("TierId", tierId);
    formData.append("Actions", data.data.actions);
    formData.append("Notes", notes);
    formData.append("StartDate", moment(startDate).format());
    formData.append("DueDate", moment(dueDate).format());
    formData.append(
      "CompletedDate",
      completedDate ? moment(completedDate).format() : completedDate
    );
    formData.append("Status", status);
    formData.append("Owner", owner);
    formData.append("Pdca", pdca);
    formData.append("Priority", priority);
    formData.append("Plan", plan);
    formData.append("Do", data.data.do);
    formData.append("Check", check);
    formData.append("Act", act);
    formData.append("top3", top3);
    formData.append("ownerEmail", ownerEmail);
    formData.append("ownerName", ownerName);

    if (imageName && imageName.length && Array.isArray(imageName)) {
      imageName.forEach((file) => {
        formData.append("files", file);
      });
    }
    formData.append("imageName", lsImageName ? lsImageName.join(",") : null);
    if (siteUid) actions.createActionRail(dispatch, formData, siteUid);
    else actions.createAction(dispatch, formData, tierId);
    setSlectedFiles(null);
    setDeleted([]);
    setToastConfig({
      ...toastConfig,
      isVisible: true,
      type: "success",
      message: "Action Rail Item Edited Successfully!!",
    });
  };

  const onRowInserted = (data) => {
    let {
      sqdcp,
      dueDate,
      notes,
      owner,
      pdca,
      priority,
      startDate,
      completedDate,
      status,
      plan,
      act,
      escTierId,
      check,
      top3,
      filePath,
      imageName,
      lsImageName = [],
      ownerEmail,
      ownerName,
    } = data.data;
    if (siteUid) {
      let getTiersList = get("tiersList");
      let tierInfo = getTiersList.find((d) => {
        if (d.tierID == data.data.tier) return d;
      });
      if (tierInfo) tierId = tierInfo.tierID;
    }
    let formData = new FormData();
    formData.append("EscTierId", escTierId | 0);
    formData.append("Sqdcp", sqdcp);
    formData.append("TierId", tierId);
    formData.append("Actions", data.data.actions);
    formData.append("Notes", notes ? notes : "");
    formData.append("StartDate", moment(startDate).format());
    formData.append("DueDate", moment(dueDate).format());
    formData.append(
      "CompletedDate",
      completedDate ? moment(completedDate).format() : ""
    );
    formData.append("Status", status);
    formData.append("Owner", owner);
    formData.append("Pdca", pdca);
    formData.append("Priority", priority);
    formData.append("Plan", plan ? plan : "");
    formData.append("Do", data.data.do ? data.data.do : "");
    formData.append("Check", check ? check : "");
    formData.append("Act", act ? act : "");
    formData.append("top3", top3 ? top3 : 9);
    formData.append("filePath", filePath && filePath[0] ? filePath[0] : null);
    formData.append("ownerEmail", ownerEmail);
    formData.append("ownerName", ownerName);
    if (imageName && imageName.length && Array.isArray(imageName)) {
      imageName.forEach((file) => {
        formData.append("files", file);
      });
    }
    formData.append("imageName", lsImageName ? lsImageName.join(",") : null);
    actions.createAction(dispatch, formData, tierId);

    setToastConfig({
      ...toastConfig,
      isVisible: true,
      type: "success",
      message: "Action Rail Item Added Successfully!!",
    });
  };

  const onRowRemoved = (data) => {
    if (siteUid) {
      let getTiersList = get("tiersList");
      let tierInfo = getTiersList.find((d) => {
        if (d.tierlevel === data.data.tierLevel) return d;
      });
      if (tierInfo) tierId = tierInfo.tierID;
    }
    let id = `&actionId=${data.data.id}&moduleID=${data.data.moduleID}&module=${data.data.module}`;
    actions.deleteAction(dispatch, id, tierId);
    setToastConfig({
      ...toastConfig,
      isVisible: true,
      type: "success",
      message: "Action Rail Item Removed Successfully!!",
    });
  };

  const handlers = {
    onRowUpdated: onRowUpdated,
    onRowRemoved: onRowRemoved,
    onRowInserted: onRowInserted,
    onEditingStart: onEditingStart,
  };

  const togglePopup = () => {
    setIsPopupVisibility(!isPopupVisible);
  };

  function populatePopupData(railData) {
    togglePopup();
    setPopupData({ railViewInfo: railData.row.data });
  }

  const handlePropertyChange = (e) => {};

  const onFileDel = (d) => {
    let deletedItems = [...delList];
    deletedItems.push(d);
    setDeleted(deletedItems);
  };

  const isRailReady = () => {
    if (siteUid && state.peopleList && state.tiersList) return true;
    else if (state.peopleList) return true;
    return false;
  };

  const cellEditFileUploader = (cellInfo) => (
    <FileUploader
      selectButtonText="Select file"
      uploadMode="uploadUrl"
      multiple={true}
      accept="*"
      labelText="Max. File Size 4 MB"
      maxFileSize={4000000}
      onValueChanged={(e) => {
        cellInfo.data.setValue(e.value);
      }}
      allowedFileExtensions={ALLOWED_FILE_EXTENSIONS}
    />
  );

  const ViewAttachment = (cellInfo) => (
    <ViewFiles
      files={cellInfo.data.value}
      folderName="Rail"
      moreInfo={cellInfo}
      onRowUpdated={onFileDel}
      updateData={(e) => {
        cellInfo.data.setValue(e);
      }}
    />
  );

  const toggleFilePopup = () => {
    setIsFilePopupVisibility(!isFilePopupVisible);
  };

  const ViewEditRPSForm = (data) => {
    if (data.data.key.moduleID && data.data.key.moduleID > 0) {
      if (data.data.key.module === "A3") {
        return data.data.key.moduleID ? (
          <a
            style={rpslink}
            onClick={() => {
              if (data.data.key.moduleID > 0) {
                setA3EditPopUpMgr(true);
                // setRPSPopUpMgr(true);
                actionA3.fetchA3GridData(dispatch, data.data.key.moduleID);
                setA3IDRail(data.data.key.moduleID);
                setRailTierId(data.data.key.tier);
              }
            }}
          >
            {data.data.key.moduleLink}
          </a>
        ) : (
          ""
        );
      } else if (data.data.key.module === "RPS") {
        return data.data.key.moduleID ? (
          <a
            style={rpslink}
            onClick={() => {
              if (data.data.key.moduleID > 0) {
                setRPSEditPopUpMgr(true);

                setRPSPopUpMgr(true);
                action.fetchRPSGridData(dispatch, data.data.key.moduleID);
                setRpsIdRail(data.data.key.moduleID);
                setRailTierId(data.data.key.tier);
              }
            }}
          >
            {data.data.key.moduleLink}
          </a>
        ) : (
          ""
        );
      } else {
        return <a style={rpslinkblank}>RPS Form Not Applicable</a>;
      }
    }
  };

  const filePathcellRender = (data) => {
    return data.value ? (
      <a
        onClick={() => {
          if (data.row.data.lsImageName) {
            setPopUpImages(data.row.data);
            setIsFilePopupVisibility(true);
          }
        }}
      >
        View Attachment
      </a>
    ) : (
      ""
    );
  };

  const exportData = () => {
    actions.exportData(
      "digitaltier/exportActionsDetails",
      "Honeywell Actions",
      {
        siteId: siteId ? siteId : siteUid,
        tierId: tierId,
        widgetId: "",
        isAll: exportFilter == 1 ? false : true,
        startDate: moment(sDate).format("DD/MM/YYYY"),
        endDate: moment(eDate).format("DD/MM/YYYY"),
      }
    );
  };

  function onHiding() {
    setToastConfig({
      ...toastConfig,
      isVisible: false,
    });
  }

  const renderFileContent = () => {
    return (
      <>
        {popUpImages.lsImageName.map((moreInfo, i) => {
          return (
            <div className="d-flex justify-content-between">
              <div
                className="file-name pointer"
                onClick={() => {
                  getTypeOfFile(
                    {
                      imageName: moreInfo,
                      fileExtension: moreInfo.split(".")[1],
                    },
                    "Rail"
                  );
                }}
              >
                {moreInfo}
              </div>{" "}
              &nbsp;
              <>
                <i
                  title="Download"
                  className="fa fa-download pointer"
                  onClick={() => onDownloadFile(moreInfo, "Rail")}
                ></i>
              </>
            </div>
          );
        })}
      </>
    );
  };

  function populatePopupRPSData(rpsdata, action) {
    setRpsIdAction(action);
    setRpsIdRail(rpsdata.row.data.id);
    setRPSEditPopUpMgr(true);
    action.fetchRPSGridData();
  }

  function getFilteredPeopleRows(options) {
    return {
      store: state.peopleList,
      filter: options.data
        ? [
            "tierid",
            "=",
            options.data.tier ? parseInt(options.data.tier) : parseInt(tierId),
          ]
        : null,
    };
  }

  const toggleLoadPanel = () => {
    setIsLoadPanelVisible(true);
  };

  const rpscellRenderWithInfo = (data) => {
    if (
      data.data.moduleID &&
      data.data.moduleID > 0 &&
      data.data.module === "RPS"
    ) {
      return data ? (
        <a
          onClick={() => {
            if (data.data.moduleID > 0) {
              setRPSEditPopUpMgr(true);

              setRPSPopUpMgr(true);
              action.fetchRPSGridData(dispatch, data.data.moduleID);
              setRpsIdRail(data.data.moduleID);
              setRailTierId(data.data.tier);
            }
          }}
        >
          {data.value}
        </a>
      ) : (
        ""
      );
    } else if (
      data.data.moduleID &&
      data.data.moduleID > 0 &&
      data.data.module === "A3"
    ) {
      return data ? (
        <a
          onClick={() => {
            if (data.data.moduleID > 0) {
              setA3EditPopUpMgr(true);

              // setRPSPopUpMgr(true);
              actionA3.fetchA3GridData(dispatch, data.data.moduleID);
              setA3IDRail(data.data.moduleID);
              setRailTierId(data.data.tier);
            }
          }}
        >
          {data.value}
        </a>
      ) : (
        ""
      );
    }
  };

  function onStatusChange(rowData, value, data, formData) {
    this.defaultSetCellValue(rowData, value);
    if (rowData.status && value === "Completed") {
      rowData.completedDate = moment(new Date()).format();
    } else if (rowData.completedDate && value !== null) {
      rowData.status = "Completed";
    }
  }

  const updateOwnerInfo = (e, d) => {
    if (d.selectedItem && d.selectedItem.employeeId) {
      e.data.setValue(d.selectedItem.employeeId);
      d.reset(d.selectedItem.employeeId);
    } else {
      e.data.setValue(d.value);
    }
  };

  const ownersStore = new CustomStore({
    key: "employeeId",
    useDefaultSearch: true,
    load: (loadOptions) => {
      let qry;
      if (
        loadOptions &&
        loadOptions.filter &&
        loadOptions.filter[0] &&
        loadOptions.filter[0][2]
      )
        qry = loadOptions.filter[0][2];
      let qryStr = qry.trim().toLowerCase();
      let keyVal = searchValueByOneProperty(qryStr);
      return actions
        .fetchHUsers(dispatch, qryStr)
        .then((data) => {
          // Transform the data to match the expected format
          // Use the `map` function to create a new array with the transformed data
          const transformedData = data.data.results.map((item) => {
            // For each item, create a new object with the expected properties
            return {
              mail: item.email,
              surname: item.familyName,
              givenName: item.givenName,
              name: `${item.familyName}, ${item.givenName}`,
              employeeId: item.username,
            };
          });
          return {
            data:
              keyVal != "employeeName"
                ? [
                    {
                      key: ORG_LBL,
                      items: transformedData, // Use the transformed data for the `ORG_LBL` key
                    },
                    {
                      key: TIER_LBL,
                      items: pplListInSite,
                    },
                  ]
                : [
                    {
                      key: TIER_LBL,
                      items: pplListInSite,
                    },
                    {
                      key: ORG_LBL,
                      items: transformedData, // Use the transformed data for the `ORG_LBL` key
                    },
                  ],
          };
        })
        .catch(() => {
          throw new Error("Data Loading Error");
        });
    },
  });

  const OwnersList = (e) => {
    return (
      <Autocomplete
        dataSource={ownersStore}
        defaultValue={e.data.row.data.ownerName}
        showClearButton={true}
        itemRender={(data) => <div>{data.name}</div>}
        onValueChanged={(d) => updateOwnerInfo(e, d)}
        //onSelectionChanged={d=> updateOwnerInfo(e, d) }
        minSearchLength={3}
        searchTimeout={500}
        placeholder="Search Owner"
        grouped={true}
      />
    );
  };

  const validateFiles = (e) => {
    const imageData = e?.newData?.imageName
      ? e.newData.imageName
      : e?.data?.imageName;
    // Check files are valid or not
    const validateUploadFiles = checkUploadFilesValid(
      imageData,
      ALLOWED_MIME_TYPES
    );

    if (validateUploadFiles.length) {
      const alertMsg = validateUploadFiles.map(
        (file) => `${file.name} - ${file.reason}`
      );
      alert(alertMsg.join("<br/>"), "Alert");
      e.cancel = true;
    }
  };

  return (
    <>
      {isRailReady() && customsqdicp && responseData && (
        <DataGrid
          ref={dataGrid}
          dataSource={state.railGridData}
          repaintChangesOnly={true}
          onSaving={validationHandler}
          showBorders={true}
          allowColumnReordering={true}
          onContentReady={onContentReady}
          onColumnsChanging={onColumnsResizing}
          onRowPrepared={onRowPrepared}
          wordWrapEnabled={true}
          onOptionChanged={handlePropertyChange}
          width={siteUid ? "97%" : "100%"}
          height="100%"
          onCellPrepared={function (e) {
            if (
              e.rowType === "filter" &&
              (e.column.dataField === "status" ||
                e.column.dataField === "sqdcp" ||
                e.column.dataField === "tierlevel" ||
                e.column.dataField === "startDate" ||
                e.column.dataField === "dueDate" ||
                e.column.dataField === "completedDate" ||
                e.column.dataField === "owner" ||
                e.column.dataField === "pdca" ||
                e.column.dataField === "priority")
            ) {
              if (e.cellElement.firstChild)
                e.cellElement.firstChild.style.display = "none";
            }
          }}
          loadPanel={{
            showPane: true,
            showIndicator: true,
            enabled: true,
          }}
          {...railConfig}
          {...handlers}
          onRowUpdating={validateFiles}
          onRowInserting={validateFiles}
        >
          <Paging defaultPageSize={10} />
          <Pager
            visible={true}
            allowedPageSizes={[5, 10, 20, 50]}
            showPageSizeSelector={true}
            showInfo={true}
            showNavigationButtons={true}
          />

          <ColumnFixing enabled={true} />
          <Export enabled={true} />
          <ColumnChooser enabled={true} />
          <Toolbar>
            <Item name="refreshButton" />
            <Item location="after" name="addRowButton"></Item>
            <Item location="after">
              <Button1 icon="export" onClick={exportData} />
            </Item>

            <Item name="columnChooserButton" />
            <Item name="searchPanel" />
          </Toolbar>
          <Column
            dataField="id"
            caption="ID"
            dataType="number"
            allowEditing={false}
            cellRender={cellRender}
            width={90}
            showInColumnChooser={false}
          ></Column>
          {siteUid && (
            <Column
              dataField="sqdcp"
              caption="SQDICP"
              dataType="string"
              width={100}
              setCellValue={setStateValue}
              showInColumnChooser={false}
            >
              <Lookup dataSource={customsqdicp} />
              <HeaderFilter dataSource={finalSQDICP} />

              <RequiredRule />
            </Column>
          )}
          {!siteUid && tab && (
            <Column
              dataField="sqdcp"
              caption="SQDICP"
              dataType="string"
              filterValues={[tab]}
              width={100}
              showInColumnChooser={false}
            >
              <Lookup dataSource={sqdicp} />
              <HeaderFilter dataSource={finalSQDICP} />

              <RequiredRule />
            </Column>
          )}
          {!siteUid && !tab && (
            <Column
              dataField="sqdcp"
              caption="SQDICP"
              dataType="string"
              width={100}
              showInColumnChooser={false}
            >
              <HeaderFilter dataSource={finalSQDICP} />
              <Lookup dataSource={sqdicp} />
              <RequiredRule />
            </Column>
          )}
          <Column
            dataField="escTierId"
            caption="Escalated"
            dataType="number"
            allowEditing={true}
          ></Column>

          <Column
            dataField="tierlevel"
            caption="Tier Level"
            dataType="number"
            allowEditing={false}
          >
            <RequiredRule />
          </Column>
          <Column
            dataField="tiername"
            caption="Tier Name"
            dataType="string"
            allowEditing={false}
          ></Column>
          <Column
            dataField="tier"
            caption="Tier Level"
            dataType="number"
            width={80}
            setCellValue={setStateValue}
            showInColumnChooser={false}
          >
            {/* {siteUid && ( */}
            <Lookup
              dataSource={getFilteredRows}
              valueExpr="tierId"
              displayExpr="customtiername"
            />
            {/* )} */}
            <RequiredRule />
          </Column>
          <Column
            dataField="actions"
            caption="Actions"
            dataType="string"
            width={650}
            cellRender={lengthyTextCellRender}
          >
            <RequiredRule />
          </Column>

          <Column
            dataField="notes"
            caption="Notes"
            dataType="string"
            width={550}
            cellRender={lengthyTextCellRender}
          ></Column>
          <Column
            dataField="startDate"
            caption="Start Date"
            dataType="date"
            width={100}
            editorOptions={{ useMaskBehavior: true }}
          >
            <RequiredRule />
          </Column>
          <Column
            dataField="dueDate"
            caption="Due Date"
            dataType="date"
            width={100}
            editorOptions={{ useMaskBehavior: true }}
          >
            <RequiredRule />
          </Column>
          {/* <Column
            dataField="rpsId"
            caption="Related To"
            dataType="string"
            allowEditing={true}            
            width={350}
            cellRender={rpscellRender}
            showInColumnChooser={false}
          ></Column> */}
          <Column
            dataField="module"
            dataType="string"
            allowEditing={false}
            showInColumnChooser={false}
          ></Column>
          <Column
            dataField="moduleID"
            caption="Related To"
            dataType="string"
            allowEditing={true}
            width={350}
            cellRender={rpscellRender}
            showInColumnChooser={false}
          ></Column>
          {/* <Column
            dataField="rpsAction"
            caption="Related To"
            dataType="string"
            allowEditing={true}
            visible={true}
            width={70}
            editCellComponent={ViewEditRPSForm}
            style={rpslinkblank}
            showInColumnChooser={true}
            cellRender={rpscellRenderWithInfo}
          ></Column> */}
          <Column
            dataField="moduleLink"
            caption="Related To"
            dataType="string"
            allowEditing={true}
            width={70}
            editCellComponent={ViewEditRPSForm}
            style={rpslinkblank}
            showInColumnChooser={true}
            cellRender={rpscellRenderWithInfo}
          ></Column>
          <Column
            dataField="completedDate"
            caption="Completed Date"
            dataType="date"
            width={110}
            editorOptions={{ useMaskBehavior: true, max: new Date() }}
            setCellValue={onStatusChange}
          ></Column>
          <Column
            dataField="openAge"
            caption="Open Age"
            dataType="number"
            format="#,##0"
            allowEditing={false}
            width={70}
          ></Column>
          <Column
            dataField="status"
            caption="Status"
            dataType="string"
            width={100}
            setCellValue={onStatusChange}
          >
            <Lookup dataSource={stat} />
            <HeaderFilter dataSource={railStatus} />
            <RequiredRule />
          </Column>
          <Column
            dataField="owner"
            caption="Owner"
            dataType="string"
            width={150}
            editCellComponent={OwnersList}
            cellRender={(data) => {
              return data.row.data.ownerName;
            }}
            setCellValue={(rowData, v) => {
              if (v && v.employeeId) {
                rowData.owner = v.employeeId;
                rowData.ownerEmail = v.mail;
                rowData.ownerName = v.name;
              }
            }}
          >
            <RequiredRule />
          </Column>

          <Column
            dataField="lsImageName"
            dataType="string"
            {...{
              caption: "Attachments",
              allowEditing: true,
              editorOption: { allowEditing: true },
            }}
            editCellComponent={ViewAttachment}
            cellRender={filePathcellRender}
          >
            <FormItem colSpan={2} />
          </Column>

          <Column
            {...{
              dataField: "imageName",
              caption: "Upload Attachments",
              allowEditing: true,
              editorOption: { allowEditing: true },
            }}
            editCellComponent={cellEditFileUploader}
            cellRender={filePathcellRender}
          >
            <FormItem colSpan={2} />
          </Column>

          {config.DEV_DISPLAY_OPTIONS && (
            <Column
              dataField="pdca"
              caption="PDCA"
              dataType="string"
              width={70}
            >
              <Lookup dataSource={pdca} />
              <RequiredRule />
            </Column>
          )}
          <Column
            dataField="priority"
            caption="Priority"
            dataType="string"
            width={100}
          >
            <Lookup dataSource={priority} />
            <RequiredRule />
          </Column>
          <Column
            dataField="plan"
            caption="Plan"
            dataType="string"
            cellRender={lengthyTextCellRender}
            width={200}
            showInColumnChooser={false}
          ></Column>
          <Column
            dataField="do"
            caption="Do"
            dataType="string"
            width={200}
            cellRender={lengthyTextCellRender}
            showInColumnChooser={false}
          ></Column>
          <Column
            dataField="check"
            caption="Check"
            dataType="string"
            width={200}
            cellRender={lengthyTextCellRender}
            showInColumnChooser={false}
          ></Column>
          <Column
            dataField="act"
            caption="Act"
            dataType="string"
            width={200}
            cellRender={lengthyTextCellRender}
            showInColumnChooser={false}
          ></Column>
          <Column
            dataField="createdDate"
            caption="Created"
            dataType="date"
            format="shortDateShortTime"
            showInColumnChooser={false}
          ></Column>
          <Column
            dataField="createdBy"
            caption="Created By"
            dataType="string"
          ></Column>
          <Column
            dataField="modifiedDate"
            caption="Modified"
            dataType="date"
            format="shortDateShortTime"
            showInColumnChooser={false}
          ></Column>
          <Column
            dataField="modifiedBy"
            caption="Modified By"
            dataType="string"
          ></Column>
          <Column
            dataField="top3"
            caption="Today's Top 3"
            dataType="string"
            cellRender={cellRender}
            showInColumnChooser={false}
          >
            <Lookup
              dataSource={[
                { id: 9, val: "Clear" },
                { id: "1", val: "1" },
                { id: "2", val: "2" },
                { id: "3", val: "3" },
              ]}
              valueExpr="id"
              displayExpr="val"
            />
          </Column>

          {/* <Column
            fixed={true}
            type="buttons"
            id="popup"
            minWidth={100}
            height="100%"
            showInColumnChooser={false}
          >
            <Button
              name="view"
              hint="View Details"
              icon="info"
              onClick={(e) => {
                populatePopupData(e);
              }}
            ></Button>
            <Button name="edit"></Button>
            <Button name="delete"></Button>
          </Column> */}
          <MasterDetail
            enabled={true}
            component={RailViewData}
            PopupData={railViewInfo}
          />
        </DataGrid>
      )}
      {isPopupVisible && (
        <Popup
          width={500}
          height={500}
          showTitle={true}
          title={"View Rail Details"}
          dragEnabled={false}
          hideOnOutsideClick={true}
          onHiding={togglePopup}
          visible={isPopupVisible}
          onOptionChanged={() => {
            dataGrid.current.instance.refresh();
          }}
          contentRender={renderContent}
        ></Popup>
      )}

      {rpsEditPopUpMgr && (
        <Sps
          rpsID={rpsIdRail}
          tierId={tierId !== "" ? tierId : railTierId}
          siteId={siteUid !== undefined ? siteUid : siteId}
          activeItem={activeItem}
          data={tabData}
          closeShift={(d) => setRPSEditPopUpMgr(d)}
          isRail={true}
        />
      )}
      {a3EditPopUpMgr && (
        <SA3
          a3ID={a3IDRail}
          tierId={tierId !== "" ? tierId : railTierId}
          siteId={siteUid !== undefined ? siteUid : siteId}
          activeItem={activeItem}
          data={tabData}
          closeShift={(d) => setA3EditPopUpMgr(d)}
          isRail={true}
          isEditable={true}
          siteDate={siteDate !== undefined ? siteDate : new Date()}
        ></SA3>
      )}

      {isFilePopupVisible && (
        <Popup
          width={600}
          height={500}
          showTitle={true}
          title={"Attachments"}
          dragEnabled={false}
          hideOnOutsideClick={true}
          onHiding={toggleFilePopup}
          visible={isFilePopupVisible}
          contentRender={renderFileContent}
        ></Popup>
      )}

      <Toast
        visible={toastConfig.isVisible}
        message={toastConfig.message}
        type={toastConfig.type}
        onHiding={onHiding}
        displayTime={2000}
      />
    </>
  );
};

export default GridView;
